/* eslint-disable react/display-name */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */

import React, { memo } from 'react';
import { Box, Text } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';

interface RequisitionNotesProps {
  note?: string;
}

export const RequisitionNotes = memo(({ note }: RequisitionNotesProps) => {
  const { t } = useTranslation('requisition');

  if (!note) return null;

  return (
    <Box mt="20px" data-testid="requisition-notes-section">
      <Text fontSize="14px" fontWeight={700} mb="6px" data-testid="requisition-notes-title">
        {t('requisitionNotes')}
      </Text>
      <Text fontSize="14px" data-testid="requisition-notes-value">
        {note}
      </Text>
    </Box>
  );
});

RequisitionNotes.displayName = 'RequisitionNotes';
